import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material'
import { translate } from '../../../i18n'

const BaseElementCountdownTimer  = styled('div')({
  display: 'flex',
  whiteSpace: 'pre-line',
  justifyContent: 'center',
})

interface CountdownTimerProps {
    initMinutes: number
    initSeconds: number
  }
  
export const CountdownTimer = (props: CountdownTimerProps) => {
  const [minutes, setMinutes] = useState(props.initMinutes)
  const [seconds, setSeconds] = useState(props.initSeconds)
  const [isTimeout, setIsTimeout] = useState(false)

  useEffect(() => {
    if (minutes === 0 && seconds === 0) {
      setIsTimeout(true)
      return
    }

    const timer = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      } else if (minutes > 0) {
        setMinutes(minutes - 1)
        setSeconds(59)
      } else {
        clearInterval(timer)
        setIsTimeout(true)
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [minutes, seconds])

  if (isTimeout) {
    return (
      <BaseElementCountdownTimer>
        {translate('reservationAcceptability.text.timeUp')}
      </BaseElementCountdownTimer>
    )
  }

  return (
    <>
      <BaseElementCountdownTimer>
        {translate('reservationAcceptability.label.remainingTime')}
      </BaseElementCountdownTimer>
      <BaseElementCountdownTimer>
        {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
      </BaseElementCountdownTimer>
    </>
  )

}
